module.exports = __webpack_public_path__ + "image/mini-logo.0b18a347.png";